var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import React, { Component } from 'react';
import { connect } from 'react-redux';
import algoliasearch from 'algoliasearch';
import './OmniSearch.css';
import { Map, List as ImuList } from 'immutable';
import StreamComponent from 'containers/stream';
import { db } from 'data/firestoreClient';
import { SocialError } from 'core/domain/common';
// - Import actions
import * as postActions from 'src/store/actions/postActions';
import * as searchActions from 'store/actions/searchActions';
import * as globalActions from 'store/actions/globalActions';
/* tslint:disable */
var OmniSearch = /** @class */ (function (_super) {
    __extends(OmniSearch, _super);
    function OmniSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.mergedPosts = Map({});
        _this.myhits = Map({});
        _this.pArr = [];
        _this.getPostById = function (postId) {
            return new Promise(function (resolve, reject) {
                var postsRef = db.doc("posts/" + postId);
                postsRef.get().then(function (snapshot) {
                    var newPost = snapshot.data() || {};
                    var post = __assign({ id: postId }, newPost);
                    resolve(post);
                })
                    .catch(function (error) {
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
        _this.dbGetPostById = function (uid, postId) {
            // alert('DB')
            return _this.getPostById(postId).then(function (post) {
                _this.props.addPost(uid, post);
            })
                .catch(function (error) {
                // dispatch(globalActions.showMessage(error.message))
            });
        };
        _this.handleKeyPress = function (event) {
            if (event.key === 'Enter') {
                _this.search();
            }
        };
        _this.postLoad = function () {
            var posts = _this.state.hits;
            var postBack = { divided: false, oddPostList: [], evenPostList: [], threePostList: [] };
            var parsedPosts = ImuList();
            _this.myhits.forEach(function (post) {
                // this.props.AddPostToSearch!(post)     
            });
            // const sortedPosts = PostAPI.sortImuObjectsDate(parsedPosts)
            if (parsedPosts.count() > 0) {
                postBack.divided = true;
            }
            else {
                postBack.divided = false;
            }
        };
        _this.search = _this.search.bind(_this);
        _this.state = {
            inputValue: '',
            hits: [],
            index: ''
        };
        return _this;
    }
    OmniSearch.prototype.componentDidMount = function () {
        var ALGOLIA_APP_ID = 'K3EYIA5OK5';
        var ALGOLIA_API_SEARCHKEY = '41f1240a843ee12d460dcb47d8b3b1dd';
        var client = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_API_SEARCHKEY, { protocol: 'https:' });
        var index = client.initIndex(this.props.index);
        this.setState({ index: index });
        while (this.pArr.length > 0) {
            this.pArr.pop();
        }
        // this.client = client
        if (this.state.inputValue === '') {
            this.props.clearState();
        }
    };
    OmniSearch.prototype.search = function () {
        var _this = this;
        this.state.index.search({
            query: this.state.inputValue
        }).then(function (data) {
            // 
            _this.setState({
                hits: data.hits
            });
            // this.myhits.setIn(data.hits.id,this.state.hits)
            // this.myhits.merge(this.state.hits)
            // this.props.AddPostToSearch!(data.hits)
            // this.props.clearState!()
            _this.pArr = [];
            data.hits.forEach(function (hit) {
                var _a;
                var p;
                var id;
                p = hit;
                if (p) {
                    id = p.id;
                }
                // 
                // this.dbGetPostById(hit.ownerUserId!, hit.id!)
                _this.props.addPost(p.ownerUserId, p);
                var myMap = Map((_a = {}, _a["" + p.id] = p, _a));
                // 
                _this.mergedPosts["" + p.ownerUserId] = myMap;
                // 
                // this.props.AddPostToSearch!(hit)
                // let newPost: any = (
                //   <div key={`${p.id}-stream-div`}>
                //       <Img3 model={p.image}></Img3>
                //     </div>
                // )
                // this.pArr.push(newPost as never) 
            });
            // this.props.clearState!()
        });
        this.postLoad();
        // 
    };
    OmniSearch.prototype.updateState = function (evt) {
        this.setState({
            inputValue: evt.target.value
        });
        // alert(this.state.inputValue)
        if (evt.target.value === '' || this.state.inputValue.length === 1) {
            this.props.clearState();
        }
    };
    OmniSearch.prototype.render = function () {
        var _this = this;
        var St = StreamComponent;
        var postList = this.postLoad();
        return (React.createElement("div", { style: { width: '100%', color: '#d0ac74' } },
            React.createElement("div", { className: 'searchContainer' },
                React.createElement("input", { className: 'searchbarheader', type: 'text', placeholder: 'search..', 
                    // ref='search'
                    onKeyDown: this.handleKeyPress, onChange: function (evt) { return _this.updateState(evt); } }),
                React.createElement("a", { className: 'btn-search' },
                    React.createElement("i", { className: 'fa fa-search' }))),
            React.createElement("div", { style: {} },
                React.createElement("div", null, this.pArr))));
    };
    return OmniSearch;
}(Component));
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    // const { post } = ownProps
    return {
        AddPostToSearch: function (post1) { return dispatch(searchActions.addPosts(post1)); },
        addPost: function (uid, post) { return dispatch(searchActions.addPost(uid, post)); },
        clearState: function () { return dispatch(searchActions.clearState()); },
        delete: function (id) { return dispatch(postActions.dbDeletePost(id)); },
        // goTo: (url: string) => dispatch(push(url)),
        setHomeTitle: function (title) { return dispatch(globalActions.setHeaderTitle(title || '')); },
    };
};
var mapStateToProps = function (state, ownProps) {
    var uid = state.getIn(['authorize', 'uid'], {});
    // const global = state.get('global', {})
    // const userProfile = state.getIn(['user', 'info', uid], {}) as Profile
    var mergedPosts = Map({});
    // const circles = state.getIn(['circle', 'circleList'], {})
    var followingUsers = state.getIn(['OmniSearch', 'ResArr'], {});
    // const Scene = state.getIn(['renderer', 'StateScene'])
    // const Camera = state.getIn(['renderer', 'StateCamera'])
    // const posts = state.getIn(['post', 'userPosts', uid ], {})
    // const hasMorePosts = state.getIn(['post', 'stream', 'hasMoreData' ], true)
    var newPosts = state.getIn(['OmniSearch', 'ResArr'], {});
    //  mergedPosts = mergedPosts.merge(newPosts)
    try {
        followingUsers.forEach(function (user, userId) {
            var newPosts = state.getIn(['OmniSearch', 'ResArr', userId], {});
            if (newPosts) {
                mergedPosts = mergedPosts.merge(newPosts);
            }
        });
    }
    catch (e) {
    }
    return {
        uid: state.getIn(['authorize', 'uid'], {}),
        //   authed: state.getIn(['authorize', 'authed'], false),
        //   isVerifide: state.getIn(['authorize', 'isVerifide'], false),
        //   translate: getTranslate(state.get('locale')),
        //   currentLanguage: getActiveLanguage(state.get('locale')).code,
        //   bag: state.getIn(['shoppingBag', 'PostArr']),
        //   name: userProfile.fullName.split(' ', 1),
        mergedPosts: mergedPosts,
    };
};
// - Connect component to redux store
export default connect(mapStateToProps, mapDispatchToProps)(OmniSearch);
// export default OmniSearch



//////////////////
// WEBPACK FOOTER
// ./src/components/OmniSearch/OmniSearch.tsx
// module id = 2012
// module chunks = 1